import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GetSearchParamsDto } from '@app/data/dtos/search/get-search-params.dto';
import { SearchHistoryRequestDto } from '@app/data/dtos/search/search-history-request.dto';
import { SearchHistoryDto } from '@app/data/dtos/search/search-history.dto';
import { SearchModelCollectionDto } from '@app/data/dtos/search/search-model-collection.dto';
import { SearchPublicationCollectionDto } from '@app/data/dtos/search/search-publication-collection.dto';
import { SearchSectionCollectionDto } from '@app/data/dtos/search/search-section-collection.dto';
import { SearchDto } from '@app/data/dtos/search/search.dto';
import { SearchRepository } from '@app/domain/repositories/search/search.repository.contract';
import { ENV } from '@environments/environment';
import { isNil, omitBy } from 'lodash-es';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class SearchRepositoryImpl extends MRepository implements SearchRepository {
  readonly #searchPath = '/api/search';
  readonly #historyPath = `${this.#searchPath}/history`;
  readonly #modelPath = `${this.#searchPath}/model`;
  readonly #publicationsPath = `${this.#searchPath}/publications`;
  readonly #sectionsPath = `${this.#searchPath}/sections`;

  constructor() {
    super(`${ENV.API_URL}`);
  }

  getSearch(searchParams: GetSearchParamsDto): Observable<SearchDto> {
    const params = omitBy(searchParams, isNil);

    return this.get<SearchDto>(this.#searchPath, { params });
  }

  getSearchHistory(): Observable<SearchHistoryDto> {
    return this.get<SearchHistoryDto>(this.#historyPath);
  }

  setSearchHistory(body: SearchHistoryRequestDto): Observable<null> {
    return this.post(this.#historyPath, { body });
  }

  getSearchModel(searchParams: GetSearchParamsDto): Observable<SearchModelCollectionDto> {
    const params = omitBy(searchParams, isNil);

    return this.get<SearchModelCollectionDto>(this.#modelPath, { params });
  }

  getSearchPublications(searchParams: GetSearchParamsDto): Observable<SearchPublicationCollectionDto> {
    const params = omitBy(searchParams, isNil);

    return this.get<SearchPublicationCollectionDto>(this.#publicationsPath, { params });
  }

  getSearchSection(searchParams: GetSearchParamsDto): Observable<SearchSectionCollectionDto> {
    const params = omitBy(searchParams, isNil);

    return this.get<SearchSectionCollectionDto>(this.#sectionsPath, { params });
  }
}
